import tagApiFactory from '../../modules/tag/tagApi';

/* Utils */
import {generateDefaultAsyncSaga, generateDefaultAsyncWatcher} from '../core/reduxUtils';

/* Actions */
import {getNextTagProductsActionCreators, getTagProductsActionCreators, getTagPageSeoActionCreators} from '../actions/tagActions';

function tagSagasFactory({storefrontApiClient}) {
  const productApi = tagApiFactory(storefrontApiClient);

  const getTagProductsSaga = generateDefaultAsyncSaga(
    productApi.getTagProducts,
    getTagProductsActionCreators,
    payload => [
      payload.params,
      payload.cookies,
    ]
  );

  const getNextTagProductsSaga = generateDefaultAsyncSaga(
    productApi.getTagProducts,
    getNextTagProductsActionCreators,
    payload => [
      payload.params,
      payload.cookies,
    ]
  );

  const getTagPageSeoSaga = generateDefaultAsyncSaga(
    productApi.getTagPageSeo,
    getTagPageSeoActionCreators,
    payload => [
      payload.params,
      payload.cookies,
    ]
  );

  const watchGetTagProducts = generateDefaultAsyncWatcher(
    'GET_TAG_PRODUCTS',
    getTagProductsSaga
  );

  const watchGetNextTagProducts = generateDefaultAsyncWatcher(
    'GET_NEXT_TAG_PRODUCTS',
    getNextTagProductsSaga,
  );

  const watchGetTagPageSeo = generateDefaultAsyncWatcher(
    'GET_TAG_PAGE_SEO',
    getTagPageSeoSaga,
  );

  const tagSagas = [
    watchGetTagProducts(),
    watchGetNextTagProducts(),
    watchGetTagPageSeo(),
  ];

  return tagSagas;
}

export default tagSagasFactory;
